import ReactPixel from "react-facebook-pixel";
import UserStore from "../../stores/UserStore"
import { triggerEvent } from "../constants/utils";

const { makeAutoObservable } = require("mobx");

class QuestionareStore {
  QUESTIONS = [] //storing questions here
  currentStepIndex = 0;

  navigate = null;

  totalScores = 0;
  selectedOptions = {};

  constructor() {
    makeAutoObservable(this);
  }

  setQuestions(data){
	  this.QUESTIONS = data
  }

  setSelectedOptions(questionKey, selectedIndices){
    this.selectedOptions[questionKey] = selectedIndices;
  }

  selectOption(optionIndex) {
  const questionKey = this.currentStepIndex;
  const isMultiSelectStep =
    this.QUESTIONS[questionKey].select_type === "multi_select";
  let selected = this.selectedOptions[questionKey] || [];

  if (isMultiSelectStep) {
    if (selected.includes(optionIndex)) {
      selected = selected.filter(idx => idx !== optionIndex);
    } else {
      selected = [...selected, optionIndex];
    }
  } else {
    this.clearCurrentSelections();
    selected = [optionIndex];
  }

  this.setSelectedOptions(questionKey, selected);

  // Update isSelected for UI rendering
  this.QUESTIONS[questionKey].options.forEach((option, idx) => {
    option.isSelected = selected.includes(idx);
  });

  this.QUESTIONS[questionKey].isComplete = this.isStepComplete();
  triggerEvent("Option_Select_prctn", {
    question: this.QUESTIONS[questionKey].question,
    value: this.QUESTIONS[questionKey].options[optionIndex].text,
  });
}

  setNavigation(navigate) {
    this.navigate = navigate;
  }

  handleBackPress = () => {
    triggerEvent("Question_Back_prctn", {
      question: this.QUESTIONS[this.currentStepIndex],
      question_no: this.currentStepIndex + 1,
    });
    this.currentStepIndex -= 1;
  };

  handleNextPress = () => {
    if (this.currentStepIndex >= this.QUESTIONS.length-1) {
      this.navigate("/prctn/score_prep");
      return;
    }

    triggerEvent("Question_Next_prctn", {
      question: this.QUESTIONS[this.currentStepIndex],
      question_no: this.currentStepIndex + 1,
    });
    this.currentStepIndex += 1;
  };

  isStepComplete = () => {
    let isComplete = false;

    // this.QUESTIONS[this.currentStepIndex].options.map((item) => {
    //   if (item.isSelected) {
    //     isComplete = true;
    //   }
    // });

    const selected_options = this.selectedOptions[this.currentStepIndex]

    return selected_options.length > 0;
  };

  isNextButtonDisabled = (isQuestion) => {
    //email input screen
    if (this.currentStepIndex == this.QUESTIONS.length) {
      return !UserStore.email || !UserStore.isEmailValid;
    } else if (isQuestion) {
      return !((this.selectedOptions[this.currentStepIndex] || []).length > 0);
    }
    //information screens
    else {
      return false;
    }
  };

  clearCurrentSelections = () => {
    this.QUESTIONS[this.currentStepIndex].options.map((item, index) => {
      this.QUESTIONS[this.currentStepIndex].options[index].isSelected = false;
    });
  };

  getTotalScore = () => {
    let scores = 0;

    this.QUESTIONS?.map((item) => {
      item?.options?.map((option) => {
        if (option.isSelected) {
          scores += option.score;
        }
      });
    });

    this.totalScores = scores;
  };
}

export default new QuestionareStore();
